import { ModalDialog } from '@local/templates/modal-dialog';
import { isEventClick, isKeyEnterOrKeySpace } from '@outbook/a11y';

export function handleModal({
  view = null,
  tabs = [],
  title,
  hasScroll = true,
  portalWrapperId = null,
  params: _params = {}
}) {
  return ev => {
    if (isEventClick(ev) || isKeyEnterOrKeySpace(ev)) {
      const targetId = ev.currentTarget.getAttribute('id');
      ModalDialog({
        title,
        hasScroll,
        tabs,
        view: view
          ? params => {
              return view({ ...params, ..._params });
            }
          : null,
        origin: targetId,
        portalWrapperId
      });
    }
  };
}
